module.exports = __webpack_public_path__ + "media/components/assets/icons/edit_pencil-440f572f5ac4d2973766eecc5f981118.svg";